import { render, staticRenderFns } from "./im-image-text-message.vue?vue&type=template&id=a515dde8&scoped=true"
import script from "./im-image-text-message.vue?vue&type=script&lang=js"
export * from "./im-image-text-message.vue?vue&type=script&lang=js"
import style0 from "./im-image-text-message.vue?vue&type=style&index=0&id=a515dde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a515dde8",
  null
  
)

export default component.exports